import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as e } from "../../../core/maybe.js";
import { getMetersPerVerticalUnitForSR as n } from "../../../core/unitUtils.js";
import { equals as o } from "../../../geometry/support/spatialReferenceUtils.js";

function t(e, n, o) {
  if (null == e.hasM || e.hasZ) {
    var _iterator = _createForOfIteratorHelper(n),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _t = _step.value;

        var _iterator2 = _createForOfIteratorHelper(_t),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e = _step2.value;
            _e.length > 2 && (_e[2] *= o);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}

function i(e, o, t) {
  if (!e && !o || !t) return;
  var i = n(t);
  s(e, t, i), s(o, t, i);
}

function s(e, n, o) {
  if (e) {
    var _iterator3 = _createForOfIteratorHelper(e),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _t2 = _step3.value;
        f(_t2.geometry, n, o);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
}

function f(i, s, f) {
  if (e(i) || !i.spatialReference || o(i.spatialReference, s)) return;
  var r = n(i.spatialReference) / f;
  if (1 !== r) if ("x" in i) null != i.z && (i.z *= r);else if ("rings" in i) t(i, i.rings, r);else if ("paths" in i) t(i, i.paths, r);else if ("points" in i && (null == i.hasM || i.hasZ)) {
    var _iterator4 = _createForOfIteratorHelper(i.points),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _e2 = _step4.value;
        _e2.length > 2 && (_e2[2] *= r);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
}

export { i as unapplyEditsZUnitScaling };